module.exports = __webpack_public_path__ + "pinIco.webp?2cbbb4f14142ac0c3278902ea91cb12b";